<div class="text-end w-100">
  <span class="apm-text-gray {{ field.className }}" *ngIf="props.compareValue">({{ props.compareValue }})</span>
  {{ field.defaultValue }} {{ props.uom }}
</div>
